export interface ExternalAuthenticationDto {
  /**
   * Auth provider id
   */
  provider: ExternalAuthenticationProvider;
  /**
   * User id
   */
  provider_key: string;
  /**
   * External Auth token
   */
  external_token: string;
  /**
   * Extra properties specific for login provider
   */
  [key: string]: any
}

export enum ExternalAuthenticationProvider {
  Facebook = 'Facebook',
  Google = 'Google',
  Apple = 'Apple',
}